import React from 'react'
import PropTypes from 'prop-types'

import CategoriesTab from './CategoriesTab'

class CategoriesTabs extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: this.props.activeTabSlug,
    }

    this.onTabClick = this.onTabClick.bind(this)
  }

  tabClassName(tabPanelComponentSlug) {
    return this.state.activeTab === tabPanelComponentSlug ? 'tab is-active' : 'tab'
  }

  onTabClick(slug) {
    this.setState({ activeTab: slug })
  }

  render() {
    return (
      <div>
        <div className="tabs-container">
          <ul className="nav-tabs">
            {this.props.tabs.map((tab) => {
              return (
                <li key={tab.slug} className={this.tabClassName(tab.slug)}>
                  <a onClick={() => { this.onTabClick(tab.slug) }}>
                    {tab.title}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>

        <div className="tabs-content">
          <div className="tab-pane is-active">
            <CategoriesTab
              competitionSlug={this.props.competitionSlug}
              categories={I18n.t(`competition.${this.props.competitionSlug}.categories.${this.state.activeTab}`)}
            />
          </div>
        </div>
      </div>
    )
  }
}

CategoriesTabs.propTypes = {
  activeTabSlug: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
  competitionSlug: PropTypes.string.isRequired,
}

export default CategoriesTabs
